/**
 * Klanten vullen in een cm-veld vaak millimeters in: 2502 in plaats van
 * 250,2. Het veld nam dat aan, de editor opende op een paneel van 25 meter
 * en leverde een drukbestand van 12 dpi (Sentry PRINTEN-EU-4E, 15-10-2026).
 *
 * Ligt de waarde boven het maximum maar past hij gedeeld door tien wel, dan
 * bedoelde de klant vrijwel zeker millimeters. Die waarde stellen we voor.
 */
export function suggestCmFromMm(value: unknown, min?: number, max?: number): number | null {
  const entered = Number(value);
  if (!Number.isFinite(entered) || entered <= 0 || max === undefined || !Number.isFinite(max)) return null;
  if (entered <= max) return null;
  const cm = Math.round(entered) / 10;
  const lower = Number.isFinite(Number(min)) ? Number(min) : 0;
  return cm >= lower && cm <= max ? cm : null;
}

const COPY = {
  nl: (cm: string) => ({ question: `Bedoel je ${cm} cm?`, hint: 'Dit veld is in centimeters.', apply: 'Aanpassen' }),
  en: (cm: string) => ({ question: `Did you mean ${cm} cm?`, hint: 'This field is in centimetres.', apply: 'Change' }),
  de: (cm: string) => ({ question: `Meinen Sie ${cm} cm?`, hint: 'Dieses Feld ist in Zentimetern.', apply: 'Übernehmen' }),
  fr: (cm: string) => ({ question: `Vouliez-vous dire ${cm} cm ?`, hint: 'Ce champ est en centimètres.', apply: 'Corriger' }),
};

export function sizeUnitHintCopy(locale: string, cm: number) {
  const key = (['en', 'de', 'fr'].includes(locale) ? locale : 'nl') as keyof typeof COPY;
  const formatted = new Intl.NumberFormat(key === 'en' ? 'en-GB' : `${key}-${key.toUpperCase()}`, { maximumFractionDigits: 1 }).format(cm);
  return COPY[key](formatted);
}
